module.exports = __webpack_public_path__ + "a6849438f55525a0066433f35c73a20f.png";